import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const LegalProcessGuide = () => {
  const [activeStep, setActiveStep] = useState(0);

  const steps = [
    {
      step: 1, title: 'Property Selection & MOU', duration: '1–2 weeks',
      description: 'Sign a Memorandum of Understanding (MOU/Form F) with the seller. Pay 10% deposit (held in escrow).',
      requirements: ['Passport copy (buyer & seller)', 'Form F (MOU) signed by both parties', '10% deposit cheque', 'Agent NOC if applicable'],
      tips: 'Ensure the MOU includes all agreed terms, fixtures, and handover date. Use a RERA-registered agent.'
    },
    {
      step: 2, title: 'Mortgage Pre-Approval', duration: '3–7 days',
      description: 'Obtain mortgage pre-approval from your chosen UAE bank. Submit income documents and property details.',
      requirements: ['6 months bank statements', 'Salary certificate / employment letter', 'Passport & visa copy', 'Property valuation report'],
      tips: 'Get pre-approval before signing MOU to avoid losing your deposit if financing falls through.'
    },
    {
      step: 3, title: 'NOC from Developer', duration: '5–10 days',
      description: 'Obtain No Objection Certificate (NOC) from the property developer confirming no outstanding dues.',
      requirements: ['Original title deed', 'Seller passport copy', 'Service charge clearance', 'Developer NOC fee (AED 500–5,000)'],
      tips: 'NOC is mandatory for all secondary market transactions. Developer fees vary significantly.'
    },
    {
      step: 4, title: 'DLD Transfer & Title Deed', duration: '1–3 days',
      description: 'Complete the property transfer at Dubai Land Department (DLD) or Abu Dhabi Municipality.',
      requirements: ['Original NOC', 'Manager cheques for purchase price', 'DLD transfer fee (4% of property value)', 'Admin fee (AED 580)', 'Title deed issuance fee (AED 250)'],
      tips: 'Both buyer and seller (or their POA holders) must be present at DLD. Bring original passports.'
    },
    {
      step: 5, title: 'RERA Registration', duration: '1–2 days',
      description: 'Register the property with RERA and obtain your new title deed in your name.',
      requirements: ['Completed DLD transfer', 'New title deed issued', 'RERA registration fee', 'Property insurance (recommended)'],
      tips: 'Your title deed is your proof of ownership. Keep it in a safe place. Digital copies available via DLD app.'
    },
  ];

  return (
    <div className="rounded-2xl p-6 md:p-8" style={{ background: 'rgba(10, 22, 40, 0.9)', border: '1px solid rgba(0, 212, 255, 0.2)' }}>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: 'rgba(0, 212, 255, 0.1)', border: '1px solid rgba(0, 212, 255, 0.3)' }}>
          <Icon name="FileText" size={20} color="#00D4FF" />
        </div>
        <div>
          <h3 className="text-lg font-bold" style={{ color: '#E8F4FF' }}>Legal Purchase Process</h3>
          <p className="text-sm" style={{ color: '#6B9EC4' }}>Step-by-step guide from MOU to title deed</p>
        </div>
      </div>
      <div className="flex gap-2 mb-6 overflow-x-auto pb-2">
        {steps?.map((s, idx) => (
          <button
            key={idx}
            onClick={() => setActiveStep(idx)}
            className="flex-shrink-0 px-3 py-2 rounded-lg text-xs font-medium transition-all duration-200"
            style={activeStep === idx ? { background: 'rgba(0, 212, 255, 0.2)', border: '1px solid rgba(0, 212, 255, 0.6)', color: '#00D4FF' } : { background: 'rgba(0, 212, 255, 0.05)', border: '1px solid rgba(0, 212, 255, 0.15)', color: '#6B9EC4' }}
          >
            Step {s?.step}
          </button>
        ))}
      </div>
      <div className="p-5 rounded-xl" style={{ background: 'rgba(0, 212, 255, 0.06)', border: '1px solid rgba(0, 212, 255, 0.25)' }}>
        <div className="flex items-start justify-between mb-3">
          <div>
            <div className="flex items-center gap-2 mb-1">
              <span className="w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold" style={{ background: '#00D4FF', color: '#000' }}>{steps?.[activeStep]?.step}</span>
              <h4 className="font-bold" style={{ color: '#E8F4FF' }}>{steps?.[activeStep]?.title}</h4>
            </div>
            <p className="text-sm" style={{ color: '#6B9EC4' }}>{steps?.[activeStep]?.description}</p>
          </div>
          <span className="flex-shrink-0 ml-3 px-2 py-1 rounded-lg text-xs" style={{ background: 'rgba(0, 212, 255, 0.1)', color: '#00D4FF', border: '1px solid rgba(0, 212, 255, 0.2)' }}>
            {steps?.[activeStep]?.duration}
          </span>
        </div>

        <div className="mb-4">
          <div className="text-xs font-semibold mb-2" style={{ color: '#00D4FF' }}>REQUIREMENTS</div>
          <div className="space-y-1.5">
            {steps?.[activeStep]?.requirements?.map((req, i) => (
              <div key={i} className="flex items-center gap-2">
                <Icon name="CheckSquare" size={14} color="#00D4FF" />
                <span className="text-sm" style={{ color: '#6B9EC4' }}>{req}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="p-3 rounded-lg" style={{ background: 'rgba(255, 200, 0, 0.06)', border: '1px solid rgba(255, 200, 0, 0.2)' }}>
          <div className="flex items-start gap-2">
            <Icon name="Lightbulb" size={14} color="#FFC800" />
            <p className="text-xs" style={{ color: '#A89060' }}>{steps?.[activeStep]?.tips}</p>
          </div>
        </div>
      </div>
      <div className="mt-4 flex items-center justify-between">
        <button
          onClick={() => setActiveStep(Math.max(0, activeStep - 1))}
          disabled={activeStep === 0}
          className="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200"
          style={{ background: activeStep === 0 ? 'rgba(0, 212, 255, 0.03)' : 'rgba(0, 212, 255, 0.1)', border: '1px solid rgba(0, 212, 255, 0.2)', color: activeStep === 0 ? '#4A7A9B' : '#00D4FF' }}
        >
          ← Previous
        </button>
        <span className="text-xs" style={{ color: '#4A7A9B' }}>{activeStep + 1} of {steps?.length}</span>
        <button
          onClick={() => setActiveStep(Math.min(steps?.length - 1, activeStep + 1))}
          disabled={activeStep === steps?.length - 1}
          className="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200"
          style={{ background: activeStep === steps?.length - 1 ? 'rgba(0, 212, 255, 0.03)' : 'rgba(0, 212, 255, 0.1)', border: '1px solid rgba(0, 212, 255, 0.2)', color: activeStep === steps?.length - 1 ? '#4A7A9B' : '#00D4FF' }}
        >
          Next →
        </button>
      </div>
    </div>
  );
};

export default LegalProcessGuide;